module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODAiIGhlaWdodD0iMTc5Ij4KICA8cGF0aCBmaWxsPSIjRjJGMkYyIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02NyAxMjcuOTUyMXYtNzcuNjEybDY3LjIxNCAzOC44MDZMNjcgMTI3Ljk1MjF6TTg5Ljc1OC4wMDAxYy00OS40MjkgMC04OS41IDQwLjA3LTg5LjUgODkuNXM0MC4wNzEgODkuNSA4OS41IDg5LjVjNDkuNDMgMCA4OS41LTQwLjA3IDg5LjUtODkuNXMtNDAuMDctODkuNS04OS41LTg5LjV6Ii8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_play.svg
// module id = 191
// module chunks = 11280160411664 35783957827783 131683993344931